/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerProfileResponseDto } from './CustomerProfileResponseDto';
import type { LocationResponseDto } from './LocationResponseDto';
import type { SaleFulfillmentSummaryDto } from './SaleFulfillmentSummaryDto';
import type { UserResponseDto } from './UserResponseDto';
export type SalesOrderResponseDto = {
  /**
   * Sales order ID
   */
  id: number;
  /**
   * Order code
   */
  orderCode: string;
  /**
   * Per-branch receipt number (client-specific)
   */
  branchReceiptCode?: string | null;
  /**
   * Order status
   */
  status: SalesOrderResponseDto.status;
  /**
   * Mixed-branch logistics progress, independent of payment status
   */
  fulfillmentStatus: SalesOrderResponseDto.fulfillmentStatus;
  /**
   * Customer handoff progress, independent of payment and logistics
   */
  deliveryStatus?: SalesOrderResponseDto.deliveryStatus;
  /**
   * Mixed-sale logistics progress counters (list views only)
   */
  fulfillmentSummary?: SaleFulfillmentSummaryDto | null;
  /**
   * Sales channel
   */
  salesChannel: SalesOrderResponseDto.salesChannel;
  /**
   * Priority level
   */
  priorityLevel: SalesOrderResponseDto.priorityLevel;
  /**
   * Subtotal
   */
  subtotal: number;
  /**
   * Discount amount
   */
  discountAmount: number;
  /**
   * Subtotal before tax
   */
  subtotalBeforeTax: number;
  /**
   * Total with tax
   */
  totalWithTax: number;
  /**
   * Total amount
   */
  totalAmount: number;
  /**
   * Total cost
   */
  totalCost: number;
  /**
   * Profit margin
   */
  profitMargin: number;
  /**
   * Has discount
   */
  hasDiscount: boolean;
  /**
   * Has partial payment
   */
  hasPartialPayment: boolean;
  /**
   * Has installments
   */
  hasInstallments: boolean;
  /**
   * Order notes
   */
  orderNotes: string;
  /**
   * Customer notes
   */
  customerNotes: string;
  /**
   * Estimated completion date
   */
  estimatedCompletion: string;
  /**
   * Last payment date
   */
  lastPaymentDate: string;
  /**
   * Next payment due date
   */
  nextPaymentDue: string;
  /**
   * Commercial sale date (business date of the transaction)
   */
  saleDate: string;
  /**
   * Creation timestamp
   */
  createdAt: string;
  /**
   * Last update timestamp
   */
  updatedAt: string;
  /**
   * Location information
   */
  location: LocationResponseDto;
  /**
   * User who created the order
   */
  createdBy: UserResponseDto;
  /**
   * Customer profile
   */
  customer?: CustomerProfileResponseDto | null;
};
export namespace SalesOrderResponseDto {
  /**
   * Order status
   */
  export enum status {
    DRAFT = 'DRAFT',
    CONFIRMED = 'CONFIRMED',
    PARTIAL_PAID = 'PARTIAL_PAID',
    PAID = 'PAID',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
  }
  /**
   * Mixed-branch logistics progress, independent of payment status
   */
  export enum fulfillmentStatus {
    NOT_REQUIRED = 'NOT_REQUIRED',
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
  }
  /**
   * Customer handoff progress, independent of payment and logistics
   */
  export enum deliveryStatus {
    NONE = 'NONE',
    PARTIAL = 'PARTIAL',
    FULL = 'FULL',
    CANCELLED = 'CANCELLED',
  }
  /**
   * Sales channel
   */
  export enum salesChannel {
    IN_STORE = 'IN_STORE',
    ONLINE = 'ONLINE',
    PHONE = 'PHONE',
    WHATSAPP = 'WHATSAPP',
  }
  /**
   * Priority level
   */
  export enum priorityLevel {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
    URGENT = 'URGENT',
  }
}
